import { useContext } from "react";
import { ThemeCtx } from "./provider";
import type { ThemeContext } from "./types";

export function useTheme(): ThemeContext {
  return useContext(ThemeCtx);
}
